import { utils } from '@yola/webapp-plugins';
import bowser from 'yola-bowser';
import { constants, selectors } from '@yola/subscription-manager-js';
import store from 'src/js/store';
import user from '../../user';

const { getDifmBannerSessionStorageValue } = utils;

const {
  SubscriptionType: { B2C_HOSTING_GOLD },
} = constants;

const DEFAULT_PREMIUM_FEATURE = 'default';

const isDifmOfferBannerVisible = (premiumFeature) => {
  const state = store.getState();
  const { id: userId } = user.selectors.getUserData(state);
  const isTouchDevice = bowser.mobile || bowser.tablet;

  const currentPlan = selectors.getCurrentPackageType(state);
  const isDefaultPremiumFeature = premiumFeature === DEFAULT_PREMIUM_FEATURE;
  const difmBannerSessionStorageValue = getDifmBannerSessionStorageValue();
  const isDifmBannerVisible = difmBannerSessionStorageValue !== userId;

  return (
    isDifmBannerVisible &&
    isDefaultPremiumFeature &&
    currentPlan !== B2C_HOSTING_GOLD &&
    !isTouchDevice
  );
};

export default isDifmOfferBannerVisible;
